export default __webpack_public_path__ + "static/media/image_conversacion.b68f611b.png";